










import { Vue, Component } from 'vue-property-decorator';
import SolicitudStock from '@/pantallas/Conecta/SolicitudStock/SolicitudStock.vue';

@Component({
  components: { SolicitudStock },
})
export default class SolicitudStockPantalla extends Vue {}
